export default {
  header: {
    title: "Bienvenue sur GenIaC",
    subtitle: "Créez, gérez et déployez vos architectures cloud en quelques clics"
  },
  setup: {
    title: "Setup rapide",
    progress: "Configuration",
    allDone: "Tout est configuré !",
    project: {
      label: "Premier projet créé",
      sublabel: "Créez un projet pour organiser vos architectures",
      action: "Créer un projet"
    },
    connection: {
      label: "Connexion cloud configurée",
      sublabel: "Connectez Azure, AWS, GCP ou Fabric",
      action: "Configurer"
    },
    devops: {
      label: "Azure DevOps configuré",
      sublabel: "Pipeline CI/CD pour vos déploiements Terraform",
      action: "Configurer"
    },
    execution: {
      label: "Première exécution lancée",
      sublabel: "Planifiez ou appliquez votre première architecture",
      action: "Lancer"
    }
  },
  steps: {
    stepLabel: "Étape",
    step1: {
      title: "Créer votre premier projet",
      description: "Organisez vos architectures cloud par projets, comme des workspaces. Chaque projet peut contenir plusieurs architectures.",
      action: "Créer un projet"
    },
    step2: {
      title: "Ajouter et préparer vos architectures",
      description: "Dans chaque projet, créez des architectures personnalisées avec notre éditeur visuel drag & drop.",
      action: "Voir les projets"
    },
    step3: {
      title: "Générer une architecture prédéfinie",
      description: "Utilisez nos templates d'architecture pour démarrer rapidement : 3-tier, microservices, serverless, et plus encore.",
      action: "Explorer les templates"
    },
    step4: {
      title: "Configurer vos connexions cloud",
      description: "Connectez vos comptes Azure, AWS ou GCP et configurez Azure DevOps pour activer les déploiements Terraform.",
      action: "Configurer"
    }
  },
  features: {
    title: "Et bien d'autres fonctionnalités...",
    list: {
      projectManagement: "Gestion de projets et architectures",
      visualEditor: "Éditeur visuel drag & drop",
      templates: "Templates prédéfinis",
      multiCloud: "Support multi-cloud (Azure, AWS, GCP)",
      exportImport: "Export et import de configurations",
      collaboration: "Collaboration d'équipe"
    }
  },
  cta: {
    button: "Commencer maintenant"
  }
};
